import { render, staticRenderFns } from "./ByTemperature.vue?vue&type=template&id=65392b59&scoped=true"
import script from "./ByTemperature.vue?vue&type=script&lang=js"
export * from "./ByTemperature.vue?vue&type=script&lang=js"
import style0 from "./ByTemperature.vue?vue&type=style&index=0&id=65392b59&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65392b59",
  null
  
)

export default component.exports